"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * EMIL InsuranceService
 * The EMIL InsuranceService API description
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kontakt@emil.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreatePremiumFormulaRequestDtoVisibilityEnum = exports.CreatePremiumFormulaRequestDtoItemTypeEnum = exports.CreatePremiumFormulaRequestDtoUnitEnum = exports.CreatePremiumFormulaRequestDtoTypeEnum = void 0;
exports.CreatePremiumFormulaRequestDtoTypeEnum = {
    Time: 'time'
};
exports.CreatePremiumFormulaRequestDtoUnitEnum = {
    Day: 'day',
    Week: 'week',
    Month: 'month',
    Quarter: 'quarter',
    Year: 'year',
    OneTimePayment: 'oneTimePayment'
};
exports.CreatePremiumFormulaRequestDtoItemTypeEnum = {
    Netto: 'netto',
    Commission: 'commission',
    Tax: 'tax',
    Discount: 'discount',
    Brutto: 'brutto',
    Other: 'other'
};
exports.CreatePremiumFormulaRequestDtoVisibilityEnum = {
    Public: 'public',
    Internal: 'internal'
};
